/** Person, Groups, License, Last login. Selection arrives with DVLP-7897. */
export const COLUMN_COUNT = 4;
